import {
	OneOrMany,
	IStorageAccessor
} from 'util/domain';
import { 
	ActionService, 
	ProgressService
} from 'phoenix/services';
import { SharedContentAction } from './sharedContent.actions';
import { SharedContent } from 'sharebase-app/dataStores/sharedContentDataStore';
import { AppAction } from '../_app/app.actions';
import { ToolbarService } from 'sharebase-app/services/appToolBarService';
import { IShareDialogService } from 'sharebase-app/services/shareDialogService';
import {
	pxItemTypeGuards as TypeGuards,
	ShareBaseDocument,
	ShareBaseFolder,
	ShareBaseItem
} from 'phoenix/domain';
import { MenuItemFactory } from 'sharebase/factories';
import {
	ActionRepository,
	ContextMenuService,
	FavoritesService
} from 'sharebase/services';
import {
	DualMenuItem,
	ValidatorPriority
} from 'sharebase/domain';
import { 
	DeleteDialogController, 
	template as DeleteDialogTemplate 
} from 'sharebase/components/deleteDialog/deleteDialog';	
import { AclDatastore } from 'sharebase/dataStores/aclDatastore';
import { CreateTaskDialog } from 'sharebase-app/components/create-task-dialog/create-task-dialog';
import { RenameDialog } from 'sharebase-app/components/renameDialog/renameDialog';	
import { ShareDialogTabs } from 'sharebase/components/shareDialog/shareDialog';
import { SelectionDataStore } from 'sharebase-app/dataStores/selectionDataStore';
import { MoveItemDialogController } from 'sharebase-app/components/moveItemDialog/moveItemDialog';
import { FolderDataStore } from 'sharebase-app/dataStores/folderDataStore';
import { DocumentDataStore } from 'sharebase-app/dataStores/documentDataStore';
import { InProgressItemsDataStore } from 'sharebase-app/dataStores/inProgressItemsDataStore';
import { DownloadDataStore } from 'sharebase-app/dataStores/downloadDataStore';


require('./sharedContent.styles');
const template = require('./sharedContent.template');

/**
 * @ngdoc directive
 * @name sharebase-app.directive:sbaSharedContent
 * @module sharebase-app
 * @restrict E
 * @description
 *
 * `sbaSharedContent` displays a user's shared content
 *
 * @usage
 *
 * <sba-shared-content item-index="0" /> 
 * 
 * @element input
 * @param {integer=} itemIndex The index of the item to be displayed at the top
 */
export function SharedContentDirective($timeout) {
	return {
		restrict: 'E',
		controller: SharedContentController,
		controllerAs: 'vm',
		template,
		bindToController: {
			itemIndex: '@'
		},
		scope: {},
		link: function (scope, element, attrs) {
			scope.$watchCollection('vm.sharedContent', function (newVal) {
				//nothing to do here
				if (!newVal) { return; }
				//no delay needed
				if (scope.vm.sbaToolbarService.viewType !== 'card' || scope.vm.itemIndex === '0' || scope.vm.itemIndex === undefined) {
					return;
				}
				//wait for the virtual tile container to render then set item index
				if (scope.vm.itemIndex !== undefined && scope.vm.itemIndex !== '0') {
					var index = scope.vm.itemIndex;
					scope.vm.itemIndex = 0;
					$timeout(function () {
						scope.vm.itemIndex = parseInt(index);
					}, 500);
				}
			});

			scope.$watchCollection('vm.sbaSharedContentDataStore.content', function(newVal) {
				if (!newVal) { return; }
				scope.vm.setFolderData(newVal);
			});

			scope.$on('$destroy', function(){
				scope.vm.removeSubscriptions();
			});
		}
	};
}

SharedContentDirective.$inject = [
	'$timeout'
];

function SharedContentController(
	$q:ng.IQService, 
	$state:ng.ui.IStateService, 
	$mdDialog:ng.material.IDialogService, 
	$window:ng.IWindowService,
	sbActionRepository:ActionRepository,
	sbToastService, 
	sbFavoritesService:FavoritesService,
	sbMenuItemFactory:MenuItemFactory,
	sbaSharedContentDataStore,
	sbaShareDialogService:IShareDialogService,
	sbaToolbarService:ToolbarService,
	sbaSelectionDataStore:SelectionDataStore,
	sbAclDatastore:AclDatastore, 
	sbaFolderDataStore:FolderDataStore,
	pxProgressService:ProgressService, 
	localStorageService:IStorageAccessor, 
	sbContextMenuService:ContextMenuService, 
	pxActionService:ActionService,
	sbaDocumentDataStore:DocumentDataStore, 
	sbaInProgressItemsDataStore:InProgressItemsDataStore,
	sbaLibraryDataStore,
	SBA_GET_REQUEST_RIGHTS_ENABLED:() => boolean,
	sbaDownloadDataStore: DownloadDataStore,
	sbaRenameDialog:RenameDialog,
	sbaMoveItemDialog:MoveItemDialogController,
	sbaCreateTaskDialog:CreateTaskDialog,
	gettextCatalog:ng.gettext.gettextCatalog
) {
	var vm = this;
	vm.loading = false;
	vm.initialIndex = 0;		
	vm.collapseView = localStorageService.getStoredValue('sba_shared_content_colaped') === 'true' ? true : false;
	vm.sbaSharedContentDataStore = sbaSharedContentDataStore;
	vm.sbaToolbarService = sbaToolbarService;
	vm.sbaToolbarService.title = gettextCatalog.getString('Shared With Me');
	vm.selectionDS = sbaSelectionDataStore;
	vm.itemClicked = itemClicked;
	vm.doneLoading = doneLoading;
	vm.setItemSelect = setItemSelect;
	vm.toggleItemSelect = toggleItemSelect;
	vm.showContextMenu = showContextMenu;
	vm.showVirtualContextMenu = showVirtualContextMenu;
	vm.removeSubscriptions = removeSubscriptions;
	vm.sharedContent = {};
	vm.setFolderData = setFolderData; 
	vm.selectedItems = [];
	vm.selectedItem;
	vm.favoriteItem = favoriteItem;
	vm.unfavoriteItem = unfavoriteItem;
	vm.inProgressDS = sbaInProgressItemsDataStore;
	vm.registeredViews =[
		{name:'list',icon:'list',label: gettextCatalog.getString('List'),remember:true},	
		{name:'card',icon:'view_module',label: gettextCatalog.getString('Tile'),remember:true}
	];

	Object.defineProperties(vm, {
		listGroups: {
			get: () => {
				return getListGroups();
			}
		}
	});

	function itemClicked(item) {
		if(vm.selectionDS.isInSelectionMode){
			toggleItemSelect(item);
			return;
		}

		//route to item
		openItem(item);
		
	}

	function openItem(item:ShareBaseItem) {
		if (TypeGuards.isShareBaseDocument(item)) {
			$state.go('content.shared.document', { 'docID': item.DocumentId });
		}
		else if (TypeGuards.isShareBaseFolder(item)) {
			$state.go('content.shared.folder', { 'folderID': item.FolderId });
		}
		else if(TypeGuards.isShareBaseLibrary(item)) {
			$state.go('content.shared.library', { 'libraryID': item.LibraryId });
		}			
	}

	function openInNew(target:ShareBaseItem){
		let params = {};
		let route = '';
		let uri = '';
		if(TypeGuards.isShareBaseLibrary(target)){
			params = {
				libraryID: target.LibraryId
			};
			route = 'content.shared.library';
		}

		uri = $state.href(route, params);
		if(uri){
			$window.open(uri);
		}
	}

	function setItemSelect(item){
		item.selected = true;
		vm.selectionDS.setItemSelect(item);
	}
	function toggleItemSelect(item){			
		item.selected = !item.selected;
		vm.selectionDS.setItemSelect(item);
	}

	function getFolderData() {
		isLoading();
		sbaSharedContentDataStore
			.getContent()
			.then((content:SharedContent) => {
				sbaToolbarService.actionTarget = [].concat(
					content.documents,
					content.folders,
					content.libraries
				);
			})
			.finally(doneLoading);
	}

	function setFolderData(data?:SharedContent){	
		if(!data){return;}		

		var folders = vm.collapseView ? data.folders.filter(function(f){ return !f.childShare; }) : data.folders;
		var documents = vm.collapseView ? data.documents.filter(function(d){ return !d.childShare; }) : data.documents;

		if(data.libraries.length>0){ vm.sharedContent.libraries = {label: gettextCatalog.getString('Corporate Libraries'), items: data.libraries};}				
		if(folders.length>0){ vm.sharedContent.folders = {label: gettextCatalog.getString('Folders'), items: folders};}
		if(documents.length>0){ vm.sharedContent.documents = {label: gettextCatalog.getString('Documents'), items:documents };}
	}
	
	function expandCollapseView(collapseView:boolean){			
		vm.collapseView = collapseView;
		localStorageService.setStoredValue('sba_shared_content_colaped', vm.collapseView);
		setFolderData(sbaSharedContentDataStore.content);
	}

	function getListGroups(){
		var items = [];

		angular.forEach(vm.sharedContent, function(group) {
			items.push(group);
			group.items.forEach(function(i) {
				items.push(i);
			});
		});
		
		return items;
	}

	function isLoading() {
		vm.loading = true;
		pxProgressService.visible = true;
	}

	function doneLoading() {
		vm.loading = false;
		pxProgressService.visible = false;
	}

	function deleteItem(item, event) {
		var purge = false;
		$mdDialog.show({
			parent: angular.element(document.body),
			controller: DeleteDialogController,
			controllerAs: 'vm',
			template: DeleteDialogTemplate,
			targetEvent: event,
			locals: { item: item },
			clickOutsideToClose: false,
			bindToController: true
		})
		.then(function(permanentlyDelete) {

			purge = permanentlyDelete;

			if (!Array.isArray(item)) {
				item = [item];
			}

			pxProgressService.visible = true;
			return $q.all(item.map(function(i) {
				if (TypeGuards.isShareBaseDocument(i)) {
					let p:ng.IPromise<any> = i.IsFavorite ? 
						sbFavoritesService.removeDocumentFromFavorites(i.DocumentId) : 
						$q.resolve();

					return p.then(() => sbaDocumentDataStore.deleteDocument(i, purge));
				}
				else {
					let p:ng.IPromise<any> = i.IsFavorite ? 
						sbFavoritesService.removeFolderFromFavorites(i.FolderId) : 
						$q.resolve();

					return p.then(() => sbaFolderDataStore.deleteFolder(i, purge));
				}
			}));
		})
		.then(function() {
			var numItems = item.length;
			var itemHasFolders = item.some(TypeGuards.isShareBaseFolder);

			var message = '';
			if (numItems === 1) {
				if (purge) {
					message = itemHasFolders ? gettextCatalog.getString('The folder has been permanently deleted') :
						gettextCatalog.getString('The document has been permanently deleted');
				}
				else {
					message = itemHasFolders ? gettextCatalog.getString('The folder has been deleted') :
						gettextCatalog.getString('The document has been deleted');
				}
			}
			else {
				message = purge ? gettextCatalog.getString('The selected items have been permanently deleted') :
					gettextCatalog.getString('The selected items have been deleted');
			}

			getFolderData();
			sbToastService.showSimple(message);
			// Clear selection when successful
			sbaSelectionDataStore.clearSelection();
		})
		.catch(function(res) {
			if (res.cancelled) {
				// user cancelled delete, do nothing
				return;
			}

			var message = '';
			var numItems = item.length;
			var itemHasFolders = item.some(TypeGuards.isShareBaseFolder);
			if (numItems === 1) {
				if (purge) {
					message = itemHasFolders ? gettextCatalog.getString('Unable to permanently delete the folder') :
						gettextCatalog.getString('Unable to permanently delete the document');
				}
				else {
					message = itemHasFolders ? gettextCatalog.getString('Unable to delete the document') :
						gettextCatalog.getString('Unable to delete the document');
				}
			}
			else {
				message = gettextCatalog.getString('Unable to delete one or more of the selected items');
			}

			sbToastService.showSimple(message);
			sbaSelectionDataStore.clearSelection();
			getFolderData();
		})
		.finally(function() {
			pxProgressService.visible = false;
		});
	}

	function showVirtualContextMenu(item){
		if(item.item && item.event){
			showContextMenu(item.item, item.event);
		}
	}
	function showContextMenu(item, event){
		vm.selectedItem = sbaSelectionDataStore.selectedItems.length===1 ? vm.selectedItems[0] : item;
		
		//load acl upfront to minimize duplicate permission request, then show context menu via service call
		sbAclDatastore.load(item)
			.then(function(){
				sbContextMenuService.open(item, event);
			});
	}
	
	var unsubs = [];
	function removeSubscriptions(){
		unsubs.forEach(function(unsubscribe){
			unsubscribe();
		});

		//remove the default folder view types
		vm.sbaToolbarService.clearViews();
	}

	function itemRename(item:ShareBaseFolder|ShareBaseDocument, $event) {
		sbaRenameDialog.open($event, item, sbaSharedContentDataStore);
	}

	function downloadItem(item:OneOrMany<ShareBaseItem>) {
		if(Array.isArray(item) && item.length === 1){
			item = item[0];
		}
		
		const context = angular.isArray(item) ? 
			gettextCatalog.getString('Shared Content') : 
			generateFileName(item);

		sbaDownloadDataStore.downloadItems(item, context);
	}

	function generateFileName(item:ShareBaseItem){
		let filename:string;
		if (TypeGuards.isShareBaseLibrary(item)) {
            filename = item.IsPrivate ? gettextCatalog.getString('Shared Content') : item.LibraryName;
		} 
		else if(TypeGuards.isShareBaseFolder(item)){
            filename = item.FolderName;
		}
		else if(TypeGuards.isShareBaseDocument(item)){
			filename = item.DocumentName;
		}
		
		return filename;
	}

	function moveItem(target, event) {
		// use the current state to determine if the folder should be moved via the library
		// data store, or the folder data store. We are assuming if the current state is 'content.myFiles.home',
		// all data is presented via the library data store, so we should use that data store to move the file
		// so the data in the UI gets updated. If the state is 'content.myFiles.folder', we are assuming the
		// data is presented using the folder data store, so we should use that to move the folder.

		sbaMoveItemDialog.open(event, target, false).then(function(item) {
				// setup the correct destination. If the destination is the metafolder "myFiles"
				// we are assuming the user is moving a folder, and they want to move it to the
				// root of their personal library, so set the destination as the personal library.
				var dest = item.destination.ref;

				if (dest === 'myFiles') {
					item.destination.ref = sbaLibraryDataStore.myLibrary;
				}

				// make sure the personal library has been loaded
				if (dest === 'myFiles' && !item.destination.ref) {
					return sbaLibraryDataStore.loadLibrary()
						.then(function(lib) {
							item.destination = { };
							item.destination.ref = lib;
							return item;
						});
				}

				return item;
			})
			.then(function(item) {
				var promise;
				var message = '';
				var dest = item.destination.ref;
				if (item.isCollection) {
					message = gettextCatalog.getString('Your items have been moved');
					// In order to have documents/folders update as they are moved,
					// we need to make sure we are calling move on the correct data store.
					// For documents, we pretty much always want to call it on the folder
					// data store so that we can update the documents collection as the move requests
					// complete.
					// For folders, we need to figure out if the current context is a folder view or
					// the root ("My Files") section. If it is the root, we need to move the item on
					// the library data store so we can update the the folders collection as items are
					// moved. If it is a folder view, call it on the folder data store.
					promise = [ ];

					if (item.collectionHasDocuments) {
						promise = promise.concat(sbaFolderDataStore.moveDocument(
							item.item.filter(TypeGuards.isShareBaseDocument),
							dest
						));
					}

					if (item.collectionHasFolders) {
						var moveFn = $state.current.name.indexOf('content.myFiles.home') >= 0 ?
							sbaLibraryDataStore.moveFolder.bind(sbaLibraryDataStore) :
							sbaFolderDataStore.moveFolder.bind(sbaFolderDataStore);

						promise = promise.concat(moveFn(
							item.item.filter(TypeGuards.isShareBaseFolder),
							dest
						));
					}

					vm.inProgressDS.setItems(target);
					promise = $q.all(promise);

				}
				else if (item.isDocument) {
					message = gettextCatalog.getString('Your document has been moved');
					vm.inProgressDS.setItems([target]);
					promise = sbaFolderDataStore.moveDocument(item.item, dest);
				}
				else {
					message = gettextCatalog.getString('Your folder has been moved');
					vm.inProgressDS.setItems([target]);
					promise = sbaFolderDataStore.moveFolder(item.item, dest);
				}
				return promise.then(function() {
					sbaSelectionDataStore.clearSelection();
					sbToastService.showSimple(message);
				})
				.catch(function(response) {
					if (!response) {
						// user cancelled dialog
						return;
					}

					if (Array.isArray(target)) {
						sbToastService.showSimple(gettextCatalog.getString('Unable to move one or more of the selected items'));
					}
					else {
						sbToastService.showSimple(gettextCatalog.getString('Unable to move the selected item'));
					}
					sbaSelectionDataStore.clearSelection();
				})
				.finally(function() {
					vm.inProgressDS.clear();
					getFolderData();
				});
			});
	}

	function copyItem(target, event) {
		sbaMoveItemDialog.open(event, target, true).then(function(item) {
				var promise;
				var message;

				if (Array.isArray(item.item)) {
					message = gettextCatalog.getString('Your documents have been copied');
					promise = $q.all(sbaDocumentDataStore.copyDocument(item.item, item.destination.ref));
				}
				else {
					message = gettextCatalog.getString('{{documentName}} has been copied', { documentName: item.item.DocumentName });
					promise = sbaDocumentDataStore.copyDocument(item.item, item.destination.ref);
				}
				return promise.then(function() {
					sbaSelectionDataStore.clearSelection();
					sbToastService.showSimple(message);
					// reload page if copying to current folder
					if (item.destination === (self as any).targetItem) {
						setFolderData();
					}
				})
				.catch(function(res) {
					if (!res) {
						// user cancelled, do nothing
						return;
					}

					var errMessage = Array.isArray(target) ? gettextCatalog.getString('Unable to copy the selected documents')
						: gettextCatalog.getString('Unable to copy the selected document');
					sbToastService.showSimple(errMessage);
				});
			});
	}

	function favoriteItem(items) {
		let message:string;
		if (!Array.isArray(items)) {
			if (TypeGuards.isShareBaseDocument(items)) {
				message = gettextCatalog.getString('{{documentName}} has been added to your favorites', { documentName: items.DocumentName });
			}
			else if (TypeGuards.isShareBaseFolder(items)) {
				message = gettextCatalog.getString('{{folderName}} has been added to your favorites', { folderName: items.FolderName });
			}
			items = [items];
		}
		else {
			message = gettextCatalog.getString('The selected items have been been favorited');
		}

		let saveNewFavorites = items.map(item => {
			if (TypeGuards.isShareBaseDocument(item)) {
				return sbFavoritesService
					.setDocumentAsFavorite(item.DocumentId)
					.then(() => {
						item.IsFavorite = true;
					});
			}
			else if (TypeGuards.isShareBaseFolder(item)) {
				return sbFavoritesService
					.setFolderAsFavorite(item.FolderId)
					.then(() => {
						item.IsFavorite = true;
					});
			}
		});

		$q.all(saveNewFavorites)
			.then(() => {
				pxActionService.emit({
					type: AppAction.RefreshSelectionBar
				});
				sbToastService.showSimple(message, 1500);
			});

	}

	function unfavoriteItem(items) {
		let message:string;
		if (!Array.isArray(items)) {
			if (TypeGuards.isShareBaseDocument(items)) {
				message = gettextCatalog.getString('{{documentName}} has been removed from your favorites', { documentName: items.DocumentName });
			}
			else if  (TypeGuards.isShareBaseFolder(items)) {
				message = gettextCatalog.getString('{{folderName}} has been removed from your favorites', { folderName: items.FolderName });
			}
			items = [items];
		}
		else {
			message = gettextCatalog.getString('The selected items have been removed from your favorites');
		}

		let saveRemovedFavorites = items.map(item => {
			if (TypeGuards.isShareBaseDocument(item)) {
				return sbFavoritesService
					.removeDocumentFromFavorites(item.DocumentId)
					.then(() => {
						item.IsFavorite = false;			
					});
			} else if (TypeGuards.isShareBaseFolder(item)) {
				return sbFavoritesService
					.removeFolderFromFavorites(item.FolderId)
					.then(() => {
						item.IsFavorite = false;			
					});
			}
		});

		$q.all(saveRemovedFavorites)
			.then(() => {
				pxActionService.emit({
					type: AppAction.RefreshSelectionBar
				});
				sbToastService.showSimple(message, 1500);
			});
	}

	function createTaskForItem(item:ShareBaseDocument, e:ng.IAngularEvent) {
		sbaCreateTaskDialog.open(e, item);
	}

	function sortView(sortType) {
		sbaSharedContentDataStore.sort(sortType);
		setFolderData(sbaSharedContentDataStore.content);
	}
	
	function shareLinkItem(item, $event) {
		if (!angular.isDefined(item.DocumentId)) {
			return;
		}

		sbaDocumentDataStore
			.load(item.DocumentId)
			.then(() => {
				sbaShareDialogService.show($event, item, sbaDocumentDataStore, ShareDialogTabs.UserShare.Create, 0);
			})
	}

	function shareItem(item, $event) {
		if (!angular.isDefined(item.DocumentId)) {
			return;
		}

		sbaDocumentDataStore
			.load(item.DocumentId)
			.then(() => {
				sbaShareDialogService.show($event, item, sbaDocumentDataStore, ShareDialogTabs.UserShare.Create, 3);
			})
	}

	getFolderData();
	
	//add the default folder view types
	vm.registeredViews.forEach(element => {
		sbaToolbarService.addView(element);	
	});	

	let sharesToggleItem = sbActionRepository
		.getActions([SharedContentAction.CollapseShares, SharedContentAction.ExpandShares])
		.map(a => sbActionRepository.createFromAction(a, !SBA_GET_REQUEST_RIGHTS_ENABLED()))
		.reduce((dualItem, item, i, arr) => {
			return dualItem || sbMenuItemFactory.createDual(AppAction.Favorite, arr[0], arr[1]);
		}, null) as DualMenuItem;
	sharesToggleItem.removeAllValidators();
	sharesToggleItem
		.getState(SharedContentAction.CollapseShares)
		.addValidator(t => !vm.collapseView, ValidatorPriority.Medium);
	sharesToggleItem
		.getState(SharedContentAction.ExpandShares)
		.addValidator(t => vm.collapseView, ValidatorPriority.Medium);
	unsubs.push(sbaToolbarService.addItem(sharesToggleItem));

	let openLibraryItem = sbActionRepository.createFromActionName(SharedContentAction.OpenLibrary);
	
	unsubs.push(sbContextMenuService.addItem(angular.copy(openLibraryItem)));
	unsubs.push(sbaSelectionDataStore.toolbar.addItem(angular.copy(openLibraryItem)));
	unsubs.push(...pxActionService.subscribe([
		[SharedContentAction.CollapseShares, () => expandCollapseView(true)],
		[SharedContentAction.ExpandShares, () => expandCollapseView(false)],
		[SharedContentAction.OpenLibrary, openItem],
		[AppAction.OpenInNew, openInNew],
		[AppAction.Rename, itemRename],
		[AppAction.Download, downloadItem],
		[AppAction.Delete, deleteItem],
		[AppAction.Move, moveItem],
		[AppAction.Copy, copyItem],
		[AppAction.CreateDocumentLinkShare, shareLinkItem],
		[AppAction.CreateDocumentUserShare, shareItem],
		[AppAction.SortChange, sortView],
		[AppAction.Favorite, favoriteItem],
		[AppAction.Unfavorite, unfavoriteItem],
		[AppAction.CreateTask, createTaskForItem]
	]));
}

SharedContentController.$inject = [
	'$q',
	'$state',
	'$mdDialog',
	'$window',
	'sbActionRepository',
	'sbToastService',
	'sbFavoritesService',
	'sbMenuItemFactory',
	'sbaSharedContentDataStore',
	'sbaShareDialogService',
	'sbaToolbarService',
	'sbaSelectionDataStore',
	'sbAclDatastore',
	'sbaFolderDataStore',
	'pxProgressService',
	'localStorageService',
	'sbContextMenuService',
	'pxActionService',
	'sbaDocumentDataStore',
	'sbaInProgressItemsDataStore',
	'sbaLibraryDataStore',
	'SBA_GET_REQUEST_RIGHTS_ENABLED',
	'sbaDownloadDataStore',
	'sbaRenameDialog',
	'sbaMoveItemDialog',
	'sbaCreateTaskDialog',
	'gettextCatalog'
];


// WEBPACK FOOTER //
// ./src/sharebase-app/components/sharedContent/sharedContent.ts